import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { LogoIcon, LogoText } from "./LogoIcon";
import { X, Camera, PlayCircle } from "lucide-react";

export default function Footer() {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();

  const navItems = [];

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="relative border-t border-white/5 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <LogoIcon size={32} />
              <LogoText height={24} />
            </div>
            <p className="font-body text-white/40 text-sm leading-relaxed max-w-xs">
              {t.footer.tagline}
            </p>
          </div>

          {/* Navigation - hidden when empty */}
          {navItems.length > 0 && (
          <div>
            <h4 className="font-display font-semibold text-white text-sm mb-4 uppercase tracking-wider">
              {t.footer.nav}
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <button
                  key={item.href}
                  onClick={() => scrollTo(item.href)}
                  data-testid={`footer-nav-${item.href.slice(1)}`}
                  className="text-left font-body text-white/40 text-sm hover:text-brand-orange transition-colors duration-300"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
          )}

          {/* Social */}
          <div>
            <h4 className="font-display font-semibold text-white text-sm mb-4 uppercase tracking-wider">
              {t.footer.social}
            </h4>
            <div className="flex gap-3">
              {[
                { icon: X, label: "X" },
                { icon: Camera, label: "Instagram" },
                { icon: PlayCircle, label: "YouTube" },
              ].map(({ icon: Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="w-9 h-9 flex items-center justify-center border border-white/10 hover:border-brand-cyan/50 text-white/40 hover:text-brand-cyan transition-all duration-300"
                  aria-label={label}
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-white/25 text-xs">
            &copy; {year} Realm Pixel Games. {t.footer.rights}
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/privacy"
              className="font-body text-white/25 text-xs hover:text-white/60 transition-colors"
            >
              {lang === "es" ? "Política de Privacidad" : "Privacy Policy"}
            </Link>
            <Link
              to="/terms"
              className="font-body text-white/25 text-xs hover:text-white/60 transition-colors"
            >
              {lang === "es" ? "Términos y Condiciones" : "Terms & Conditions"}
            </Link>
            <p className="font-body text-white/15 text-xs">
              realmpixelgames@gmail.com
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
